import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { ReferencesLayout } from '../Layout';

function ReferencesTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleReferencesFormLoad = useCallback(() => {
        // Form load callback - can be used for any initialization if needed
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='5FA91CDE-B3B2-4C36-9966-C5C49E157186'
                layoutName='WMChargeCodeReferencesForm'
                defaultFormSchema={ReferencesLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleReferencesFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(ReferencesTab);

